import localForage from 'localforage'

// Album metadata only: never store OAuth tokens. Keep interrupted scans for 30 days.
const store = localForage.createInstance({ name: 'spotify-release-list-scan-progress' })
const MAX_AGE = 30 * 24 * 60 * 60 * 1000

async function stored(operation) {
  try {
    return await operation()
  } catch {
    throw new Error(
      'Scan stopped because this browser could not read or save scan progress. Allow browser storage and free some space before trying again. Previously saved pages are kept.'
    )
  }
}

export async function beginAlbumScan(user) {
  if (!user.id) throw new Error('Cannot save scan progress without a Spotify user ID.')
  const identity = JSON.stringify([user.id, user.country || ''])
  const key = `session:${identity}`
  return stored(async () => {
    const existing = await store.getItem(key)
    if (existing && !existing.complete && Date.now() - existing.startedAt < MAX_AGE) {
      return { key, ...existing }
    }
    const session = {
      id: `${identity}:${Date.now()}:${Math.random().toString(36).slice(2)}`,
      startedAt: Date.now(),
      complete: false,
    }
    // Publish the new session before removing old pages; never reuse a partial cleanup.
    await store.setItem(key, session)
    if (existing) {
      const prefix = `page:${existing.id}:`
      for (const pageKey of await store.keys()) {
        if (pageKey.startsWith(prefix)) await store.removeItem(pageKey)
      }
    }
    return { key, ...session }
  })
}

export async function readAlbumPage(session, endpoint) {
  return stored(() => store.getItem(`page:${session.id}:${endpoint}`))
}

export async function saveAlbumPage(session, endpoint, response) {
  await stored(() => store.setItem(`page:${session.id}:${endpoint}`, response))
}

export async function completeAlbumScan(session) {
  await stored(async () => {
    const current = await store.getItem(session.key)
    if (current?.id === session.id) {
      await store.setItem(session.key, { ...current, complete: true })
    }
  })
}
